var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.036 12.049c.159 1.057.838 1.951 1.787 2.298l4.353 1.593c1.09.398 1.825 1.519 1.824 2.78V21H1v-2.28c0-1.26.735-2.38 1.824-2.778l4.352-1.589c.95-.347 1.631-1.244 1.79-2.304-1.817-1.202-3.088-3.821-3.088-5.927a5.122 5.122 0 0110.244 0c0 2.105-1.27 4.725-3.086 5.927z",
    stroke: "#0B966B",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconPerson;